import React from "react";
import { useLang } from '../contexts/LanguageContext';
import { Container } from "react-bootstrap";
import NavbarHome from '../components/NavbarIndex';
import FormQuestion from "../components/FormQuestion";
import Footer from "../components/Footer";


export default function HelpUs() {

  /* Variable de traducción */
  const { t } = useLang();

  return (
    <div>
      <NavbarHome static_page="true" />
      <Container>
        <h1>{t("HELP_US_TITLE")}</h1>
        <p>{t("HELP_US_TEXT")}</p>
        <FormQuestion formName="HelpUs"/>
      </Container>
      <Footer />
    </div>
  );
}
